import React from 'react'
import { Menubar } from 'primereact/menubar';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import Users from "./settings/Users";
import Disabilities from './settings/Disabilities';
import Roles from './settings/Roles';








const Settings = () => {

    const navigate = useNavigate();

  const items = [
    {
        label: 'Users',
        icon: 'pi pi-fw pi-users',
        items: [
            {
                label: 'Users',
                icon: 'pi pi-fw pi-users',
                command: () => { navigate("users"); },
                
            },

            {
                label: "Roles",
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("roles"); },
            },
            {
                separator: true
            },
        ]
      },
    
    {
        label: 'Categorization',
        icon: 'pi pi-fw pi-sitemap',
        items: [
            {
                label: 'BroadCategories',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("broadcategories"); },
            },
            {
                label: 'Categories',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("categories"); }
            },
            {
                label: 'SubCategories',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("subcategories"); }
            },
            {
                label: 'Incident Status',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("incidentstatuses"); }
            },
            {
                label: 'Response Status',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("incidentresponsestatuses"); }
            },

        ]
      },
    
      {
        label: 'Issues & Rights',
        icon: 'pi pi-fw pi-pencil',
        items: [
            {
                label: 'Rights',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("rights"); }
            },
            {
                label: 'Issues',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("issues"); }
            },

        ]
      },
    
    {
        label: 'Bio Data',
        icon: 'pi pi-fw pi-user',
        items: [
            {
                label: 'Religions',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("religions"); }

            },
            {
                label: 'Tribes',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("tribes"); }

            },
            {
                label: 'Marital Statuses',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("maritalstatuses"); }
            },
            {
                label: 'Employment Statuses',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("employmentstatuses"); }
            },
            {
                label: 'Marriage Type',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("marriagetypes"); }
            },
            {
                label: 'Vulnerabilities',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("vulnerabilities"); }
            },
            {
                label: 'Disabilities',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("disabilities"); }
            },

        ]
    },
    {
        label: 'Location',
        icon: 'pi pi-fw pi-map-marker',
        items: [
            {
                label: 'Countries',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("countries"); }
            },
            {
                label: 'Zone',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("zones"); }
            },
            {
                label: 'Regions',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("regions"); }
            },
            {
                label: 'Districts',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("districts"); }
            },
            {
                label: 'Wards',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("wards"); }
            }
        
        ]
      },
      {
        label: 'Resources',
        icon: 'pi pi-fw pi-book',
        items: [
            {
                label: 'Manuals',
                icon: 'pi pi-fw pi-align-justify',
                command: () => { navigate("manualssettings"); }
            },
        ]
    },
    {
        label: 'Miscellaneous',
        icon: 'pi pi-fw pi-info-circle'
    }
];




  return (
    <div className="card bg-white p-1">
          <Menubar model={items} />
          <Outlet/>        

    </div>
  )

   
}

export default Settings